// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__tYdW9","important":"IconButton_important__LZxe7","blank":"IconButton_blank__-iT5J"};